const EVENTS = {
    SKIP: 'skip',
    SKIPPED: 'skipped',
    CLICK: 'click'
};

const ROUTES = {
    HOME: 'Home',
    DEVICES: 'Devices',
    AUTH: 'Auth',
    PANEL: 'Panel',
    ANALYTICS: 'Analytics',
    ANALYTICS_SELECT: 'Analyticsselect',
    STATISTICS: 'Statistics',
    BANNERS: 'Banners',
    PRODUCTS: 'Products',
    PRINTERS: 'Printers',
    CONFIG: 'Config',
    PRICES: 'Prices',
    ORDERS: 'Orders',
    TEMPLATES: 'Templates',
    ACCOUNT: '/Account',
    ERROR: 'Error',
    LOGIN: 'Login',
    WELCOME: 'Welcome',
    UNAUTHORIZED: 'Unauthorized',
    REGISTRATION: 'Registration',
    REGISTRATION_SHOP: 'Registrationshop',
    REGISTRATION_USER: 'Registrationuser',
    PROMOTIONS: 'Promotions',
    API_BROWSER: '/ApiBrowser',
    SHOPS: 'Shops',
    SHOP_FORM: 'Shop/form',
    USERS: 'Users',
    EDIT: 'edit'
};

const ROLES = {
    ADMIN: 'admin',
    KEY_ACCOUNT: 'key_account',
    SHOP_OWNER: 'shop_owner',
    SALES: 'sales',
    OPERATOR: 'operator',
    PARTNER: 'partner'
};

const ACTIONS = {
    REMOVE: 'remove',
    ADD: 'add',
    UPDATE: 'update',
    READ: 'read',
    VIEW: 'view'
};

const HTTPCODES = {
    '200': 'OK',
    '201': 'Created',
    '202': 'Accepted',
    '204': 'No content',
    '301': 'Moved permanently',
    '304': 'Not modified',
    '400': 'Bad request',
    '401': 'Unauthorized',
    '402': 'Payment required',
    '403': 'Forbidden',
    '404': 'Not found',
    '405': 'Method not allowed',
    '406': 'Not acceptable',
    '407': 'Proxy Authentication Required',
    '408': 'Request Timeout',
    '409': 'Conflict',
    '410': 'Gone',
    '411': 'Length Required',
    '412': 'Precondition Failed',
    '413': 'Request Entity Too Large',
    '414': 'Request-URI Too Long',
    '415': 'Unsupported Media Type',
    '416': 'Requested Range Not Satisfiable',
    '417': 'Expectation Failed',
    '418': 'Request Entity Too Large',
    '428': 'Precondition Required',
    '429': 'Too Many Requests',
    '444': 'No Response',
    '422': 'Request Entity Too Large',
    '500': 'Internal Server Error',
    '501': 'Not Implemented',
    '502': 'Bad Gateway',
    '503': 'Service Unavailable',
    '504': 'Gateway Timeout',
    '505': 'HTTP Version Not Supported',
    '510': 'Not Extended',
    '511': 'Network Authentication Required',
    '598': 'Network read timeout error',
    '599': 'Network connect timeout error'
};

export {
    EVENTS,
    ROUTES,
    HTTPCODES,
    ROLES,
    ACTIONS
};

export const TypesPlugin = {
    install: (Vue) => {
        Vue.prototype.$TYPES = {
            EVENTS,
            ROUTES,
            HTTPCODES,
            ACTIONS,
            ROLES
        };
    }
};
